const https = require("https");

module.exports = function getFetchAgent() {
	return new https.Agent({
		// rejectUnauthorized: process.env.NODE_ENV !== "development",
		rejectUnauthorized: false,
	});
};
